// extracted by mini-css-extract-plugin
module.exports = {"category-tabs":"a10a3f92e9--category-tabs--YVMja","tab":"a10a3f92e9--tab--SBMdh","active":"a10a3f92e9--active--yVemV"};